import { Box, Backdrop, CircularProgress, Grid } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomDataGrid from "../../CustomComponents/CustomDataGrid";

const FeeChargesDetails = () => {
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState();
  const [rowData, setRowData] = useState([]);
  const filterScreen = useSelector((state) => state.cov.filterScreen);
  const [total, settotal] = useState({
    paid: 0,
    due: 0,
    waived: 0,
  });

  useEffect(() => {
    const appNum = localStorage.getItem("appNum");
    getFeeData(appNum);
  }, []);

  const getFeeData = async (appNum) => {
    setLoading(true);
    const response = await axios.post("/customerOneView/getFeeAndChargesData", {
      applicationNum: appNum,
      type: "accrual",
    });
    var paidTotal = 0;
    var dueTotal = 0;
    var waivedTotal = 0;
    if (response.status === 200) {
      response.data.gridData.map((record) => {
        paidTotal = paidTotal + record.received;
        dueTotal = dueTotal + record.receiveable;
        waivedTotal = waivedTotal + record.earlyWaiver;
      });
      settotal({
        paid: paidTotal,
        due: dueTotal,
        waived: waivedTotal,
      });
      setRowData(response.data.gridData);
      setLoading(false);
    }
  };

  const columnsData = [
    {
      field: "details",
      headerName: "Memo Description",
      headerAlign: "center",
      flex: 452,
      align: "left",
    },
    {
      field: "receiveable",
      headerName: "Due Amount (₹)",
      headerAlign: "center",
      flex: 200,
      align: "right",
      renderCell: (params) => {
        return <>{parseInt(params.value).toLocaleString("en-IN")}</>;
      },
    },
    {
      field: "received",
      headerName: "Paid Amount  (₹)",
      headerAlign: "center",
      flex: 200,
      align: "right",
      renderCell: (params) => {
        return <>{parseInt(params.value).toLocaleString("en-IN")}</>;
      },
    },
    {
      field: "earlyWaiver",
      headerName: "Waived Amount (₹)",
      headerAlign: "center",
      flex: 210,
      align: "right",
      renderCell: (params) => {
        return <>{parseInt(params.value).toLocaleString("en-IN")}</>;
      },
    },
    {
      field: "osAmount",
      headerName: "Outstanding Amount  (₹)",
      headerAlign: "center",
      flex: 210,
      align: "right",
      renderCell: (params) => {
        var value =
          params.row.receiveable - params.row.received - params.row.earlyWaiver;
        return <>{parseInt(value).toLocaleString("en-IN")}</>;
      },
    },
  ];
  return (
    <>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      )}
      <Box sx={{ marginTop: "10px" }}>
        <Grid container spacing={0}>
          <Grid
            sx={{ marginLeft: "80px" }}
            item
            xs={12}
            sm={5}
            md={4}
            lg={2.2}
            xl={3}
          >
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
              }}
            >
              {"Due (₹) : "}
              <span style={{ color: "#2F7DC4" }}>
                {parseInt(total.due).toLocaleString("en-IN")}
              </span>
              {``}
            </label>
          </Grid>
          <Grid item xs={12} sm={5} md={4} lg={2.2} xl={3}>
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
              }}
            >
              {"Paid (₹) : "}
              <span style={{ color: "#2F7DC4" }}>
                {parseInt(total.paid).toLocaleString("en-IN")}
              </span>
              {``}
            </label>
          </Grid>
          <Grid item xs={12} sm={5} md={4} lg={2.2} xl={3}>
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
              }}
            >
              {"Waived (₹) : "}
              <span style={{ color: "#2F7DC4" }}>
                {parseInt(total.waived).toLocaleString("en-IN")}
              </span>
              {``}
            </label>
          </Grid>
          <Grid item xs={12} sm={5} md={4} lg={2.2} xl={3}>
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
              }}
            >
              {"Outstanding (₹) : "}
              <span style={{ color: "#2F7DC4" }}>
                {parseInt(total.due - total.paid - total.waived).toLocaleString(
                  "en-IN"
                )}
              </span>
              {``}
            </label>
          </Grid>
        </Grid>
        <CustomDataGrid
          noDataMessage="No Data."
          noDataOnFilterMessage="No Data on Applied Filter."
          rows={rowData}
          gridHeight={
            // rowData.length < 5 && rowData.length !== 0
            //   ? rowData.length * 40 + 130
            rowData.length === 0 ? 300 : 480
          }
          gridWidth={1280}
          onPageSizeChange={(pageSize) => {
            setPageSize(pageSize);
          }}
          columns={columnsData}
          pageSize={10}
          pageSizeOptions={[]}
          gridLazyLoad={() => {}}
          onSortModelChange={() => {}}
        />
      </Box>
    </>
  );
};
export default FeeChargesDetails;
